// /pages/stanley 때는 .brand-menu 숨김처리  
  // if (window.location.pathname !== "/pages/stanley") {
  //   var el = document.querySelector('.brand-menu');
  //   if (el) el.style.display = "flex";
  // }

  // if (window.location.pathname === "/pages/stanley") {
  //   var el = document.querySelector('.brand-menu');
  //   if (el) el.style.display = "none";
  // }

// 이미지 클릭 시 코드 복사
  document.addEventListener("DOMContentLoaded", () => {
    const copyBtn = document.querySelector(".b7-copy-code__btn");

    copyBtn.addEventListener("click", async () => {
      const code = document.querySelector(".b7-copy-code").innerText;

      try {
        await navigator.clipboard.writeText(code);
        alert("코드가 복사되었습니다.");
      } catch (e) {
        console.error("복사 실패", e);
      }
    });

  });